<template>
  <div
    class="d-flex flex-column mx-auto question-answer"
    role="radiogroup"
    :aria-labelledby="inputFor"
  >
    <div class="d-flex">
      <bs-tooltip title="Non Applicable" placement="bottom">
        <div
          key="N.A."
          class="input-radio input-radio--n-a"
          :class="radioClass('N.A.')"
          :name="inputName"
          role="radio"
          :aria-checked="radioStatus('N.A.')"
          tabindex="0"
          @click="updateValue('N.A.')"
        >
          <div class="input-radio__bubble"></div>
          <div class="input-radio__text input-radio__text--n-a">N.A.</div>
        </div>
      </bs-tooltip>
      <div
        v-for="index in 10"
        :key="index"
        class="input-radio"
        :class="radioClass(index)"
        :name="inputName"
        role="radio"
        :aria-checked="radioStatus(index)"
        tabindex="-1"
        @click="updateValue(index)"
      >
        <div class="input-radio__bubble"></div>
        <div class="input-radio__text">{{ index }}</div>
      </div>
    </div>
    <button
      v-if="form.value"
      class="btn btn-link delete-button"
      @click="deleteResponse()"
    >
      Supprimer la réponse
    </button>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    inputFor: {
      type: String,
      required: true,
    },
    inputReference: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        survey_question_id: this.question.id,
        value: this.question.value ?? null,
      }),
    }
  },
  computed: {
    inputName() {
      return `${this.inputReference}`
    },
    userSurvey() {
      return this.$page.props.survey
    },
    userSurveyId() {
      return this.userSurvey.id
    },
  },
  methods: {
    radioClass(index) {
      return index == this.form.value ? 'input-radio--checked' : null
    },
    radioStatus(index) {
      return index == this.form.value
    },
    updateValue(index) {
      if (this.form.progress) {
        return
      }
      this.form.value = index
      this.submit()
    },
    submit() {
      this.form.post(
        this.$route('survey.user.addResponse', this.userSurveyId),
        {
          preserveScroll: true,
          resetOnSuccess: false,
          onError: (errors) => {
            this.$toasted.global.savingError()
            console.error(errors)
          },
        }
      )
    },
    deleteResponse() {
      if (this.form.progress) {
        return
      }
      const initialValue = this.form.value
      this.form.value = null
      this.form.delete(
        this.$route('survey.user.deleteResponse', {
          id: this.userSurveyId,
          questionId: this.question.id,
        }),
        {
          preserveScroll: true,
          resetOnSuccess: false,
          onError: (errors) => {
            this.form.value = initialValue
            this.$toasted.global.savingError()
            console.error(errors)
          },
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.question-answer {
  --font-size: 0.9rem;
  --bubble-size: calc(var(--font-size) * 1.4);
  --horizontal-padding: calc(var(--font-size) * 0.9);
  --bubble-border-radius: calc(var(--font-size) * 7.5);
  .input-radio {
    display: flex;
    place-content: center;
    flex-direction: column-reverse;
    place-items: center;

    border-radius: var(--bubble-border-radius);
    padding: calc(var(--bubble-size) / 2) var(--horizontal-padding);
    margin: calc(var(--bubble-size) / 2) 0;

    cursor: pointer;
    transition: 0.3s;
    &--n-a {
      padding: calc(var(--bubble-size) / 2) calc(var(--horizontal-padding) / 2);
    }
    &:hover,
    &:focus-within {
      background: hsla(0, 0%, 80%, 0.14);
    }
    &__bubble {
      width: var(--bubble-size);
      height: var(--bubble-size);
      border-radius: var(--bubble-border-radius);
      background: linear-gradient(
        to right bottom,
        var(--bs-primary),
        var(--bs-secondary)
      );
      position: relative;
      &:before {
        content: '';
        display: inline-block;
        width: inherit;
        height: inherit;
        border-radius: inherit;
        background: hsl(0, 0%, 90%);
        transform: scale(1.1);
        transition: 0.3s;
      }
    }
    &__text {
      color: hsl(0, 0%, 60%);
      text-align: center;
      text-transform: uppercase;
      font-size: var(--font-size);
      font-weight: 500;
      transition: 0.3s;
      &--n-a {
        transform: scaleX(0.8);
      }
    }

    &--checked {
      .input-radio {
        &__bubble {
          &:before {
            transform: scale(0);
          }
        }
        &__text {
          color: hsl(0, 0%, 40%);
          font-weight: 600;
        }
      }
    }
  }
  .delete-button {
    height: 1em;
    font-size: 0.5rem;
    margin-top: -1em;
    align-self: end;
  }
}
</style>
